import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WireframeGlobe } from './WireframeGlobe';
export function Hero() {
  return <section className="relative pt-28 pb-16 lg:pt-32 lg:pb-24 overflow-hidden bg-[#0a0a0a]" data-id="element-63">
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-64">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-65">
          {/* Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-66">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} data-id="element-67">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium text-white leading-[1.1] mb-6 tracking-tight" data-id="element-68">
                Evoluciona tu negocio hacia un ecosistema digital de{' '}
                <span className="text-white" data-id="element-69">alto rendimiento</span>
              </h1>

              <p className="text-lg text-gray-400 mb-10 max-w-xl leading-relaxed" data-id="element-70">
                Creamos tu página web, carta digital y perfiles sociales desde
                cero. Un ecosistema digital completo que convierte visitantes en
                clientes fieles.
              </p>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-71">
                <Link to="/checkout" className="inline-flex justify-center items-center gap-2 bg-brand-emerald text-[#0a0a0a] px-8 py-3.5 rounded-xl font-medium text-[15px] hover:bg-brand-emeraldLight transition-colors group" data-id="element-72">
                  Empezar ahora
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-73" />
                </Link>
                <Link to="/proceso" className="inline-flex justify-center items-center gap-2 bg-white/[0.03] text-white border border-white/[0.05] px-8 py-3.5 rounded-xl font-medium text-[15px] hover:bg-white/[0.06] transition-colors group" data-id="element-74">
                  <div className="w-6 h-6 rounded-full bg-white/[0.05] flex items-center justify-center group-hover:bg-white/[0.1] transition-colors" data-id="element-75">
                    <Play size={12} className="text-white ml-0.5" data-id="element-76" />
                  </div>
                  Ver cómo funciona
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Wireframe Globe Composition */}
          <div className="w-full lg:w-1/2 relative h-[300px] sm:h-[400px] lg:h-[500px] flex items-center justify-center overflow-hidden" data-id="element-77">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.2
          }} className="relative w-full h-full flex items-center justify-center" data-id="element-78">
              <WireframeGlobe size={550} className="absolute inset-0 z-10" data-id="element-79" />
            </motion.div>
          </div>
        </div>
      </div>

      {/* Pricing / Value Proposition Strip */}
      <div className="container mx-auto px-6 md:px-12 mt-20 relative z-20" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="card-premium" data-id="element-81">
          <div className="relative z-10 p-6 sm:p-10 lg:p-12" data-id="element-82">
            {/* Main Content: 3 Column Layout */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-white/[0.05] rounded-xl overflow-hidden border border-white/[0.05]" data-id="element-83">
              {/* Total Price Card */}
              <div className="flex flex-col items-center justify-center text-center p-8 bg-[#111] relative" data-id="element-84">
                <h3 className="text-lg text-white font-medium mb-1" data-id="element-85">
                  Ecosistema Completo
                </h3>
                <p className="text-[13px] text-gray-500 mb-6" data-id="element-86">
                  Todo lo que necesitas, sin costes ocultos
                </p>

                <div className="text-5xl font-medium text-gradient tracking-tight mb-8" data-id="element-87">
                  350€
                </div>

                <div className="section-divider-emerald mb-6" data-id="element-88"></div>

                <div className="flex flex-col gap-3 text-left w-full" data-id="element-89">
                  <div className="flex items-center gap-3 text-[13px] text-gray-400" data-id="element-90">
                    <CheckCircle2 size={14} className="text-brand-emerald shrink-0" data-id="element-91" />
                    <span data-id="element-92">Página web profesional a medida</span>
                  </div>
                  <div className="flex items-center gap-3 text-[13px] text-gray-400" data-id="element-93">
                    <CheckCircle2 size={14} className="text-brand-emerald shrink-0" data-id="element-94" />
                    <span data-id="element-95">Carta digital interactiva</span>
                  </div>
                  <div className="flex items-center gap-3 text-[13px] text-gray-400" data-id="element-96">
                    <CheckCircle2 size={14} className="text-brand-emerald shrink-0" data-id="element-97" />
                    <span data-id="element-98">Configuración de redes sociales</span>
                  </div>
                </div>
              </div>

              {/* Pago Inicial */}
              <div className="flex flex-col p-8 bg-[#111] hover:bg-[#131313] transition-colors" data-id="element-99">
                <div className="flex items-center justify-between mb-6" data-id="element-100">
                  <div data-id="element-101">
                    <h4 className="text-white font-medium text-lg mb-0.5" data-id="element-102">
                      Reserva
                    </h4>
                    <span className="badge-premium mt-2" data-id="element-103">
                      Inicio del proyecto
                    </span>
                  </div>
                  <div className="text-2xl font-medium text-white" data-id="element-104">50€</div>
                </div>

                <p className="text-gray-400 text-[13px] leading-relaxed mb-8" data-id="element-105">
                  Abono anticipado para confirmar tu proyecto. Comenzamos a
                  diseñar y desarrollar el mismo día.
                </p>

                <div className="mt-auto flex flex-col gap-3" data-id="element-106">
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-107">
                    <CheckCircle2 size={14} className="text-gray-500 shrink-0 mt-0.5" data-id="element-108" />
                    <span data-id="element-109">Inicio inmediato tras la confirmación</span>
                  </div>
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-110">
                    <CheckCircle2 size={14} className="text-gray-500 shrink-0 mt-0.5" data-id="element-111" />
                    <span data-id="element-112">Primer borrador en 24–48h</span>
                  </div>
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-113">
                    <CheckCircle2 size={14} className="text-gray-500 shrink-0 mt-0.5" data-id="element-114" />
                    <span data-id="element-115">Comunicación directa continua</span>
                  </div>
                </div>
              </div>

              {/* Pago Final */}
              <div className="flex flex-col p-8 bg-[#111] hover:bg-[#131313] transition-colors" data-id="element-116">
                <div className="flex items-center justify-between mb-6" data-id="element-117">
                  <div data-id="element-118">
                    <h4 className="text-white font-medium text-lg mb-0.5" data-id="element-119">
                      Entrega
                    </h4>
                    <span className="badge-premium mt-2" data-id="element-120">
                      Satisfacción 100%
                    </span>
                  </div>
                  <div className="text-2xl font-medium text-gradient" data-id="element-121">300€</div>
                </div>

                <p className="text-gray-400 text-[13px] leading-relaxed mb-8" data-id="element-122">
                  Solo pagas cuando estés 100% satisfecho con el resultado
                  final. Sin letra pequeña.
                </p>

                <div className="mt-auto flex flex-col gap-3" data-id="element-123">
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-124">
                    <CheckCircle2 size={14} className="text-brand-emerald/60 shrink-0 mt-0.5" data-id="element-125" />
                    <span data-id="element-126">Revisiones ilimitadas hasta tu aprobación</span>
                  </div>
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-127">
                    <CheckCircle2 size={14} className="text-brand-emerald/60 shrink-0 mt-0.5" data-id="element-128" />
                    <span data-id="element-129">Tú decides cuándo está listo</span>
                  </div>
                  <div className="flex items-start gap-3 text-[13px] text-gray-400" data-id="element-130">
                    <CheckCircle2 size={14} className="text-brand-emerald/60 shrink-0 mt-0.5" data-id="element-131" />
                    <span data-id="element-132">Sin compromiso si no te convence</span>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Row */}
            <div className="mt-10 flex flex-col items-center justify-center text-center" data-id="element-133">
              <Link to="/checkout" className="inline-flex justify-center items-center gap-2 bg-brand-emerald text-[#0a0a0a] px-8 py-3.5 rounded-xl font-medium text-[15px] hover:bg-brand-emeraldLight transition-colors group" data-id="element-134">
                Empezar ahora
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-135" />
              </Link>
              <p className="mt-3 text-[12px] text-gray-500" data-id="element-136">
                Sin compromiso · Respuesta en 24h
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}